<template>
  <div class="layout">
    <CrudLocation />
  </div>
</template>



<script>
// @ is an alias to /src
import CrudLocation from "@/components/components-planning/admin/location/CrudLocation";

export default {
  components: {
    CrudLocation,
  },
}
</script>


<style lang="scss" scoped>
.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

</style>
